import { configureStore } from '@reduxjs/toolkit'

import auth from './features/auth'
import itineraries from "./features/itineraries.ts";
import agencies from "./features/agencies.ts";
import tripbooks from "./features/tripbooks.ts";
import config from './features/config.ts'

export const store = configureStore({
  reducer: {
    auth,itineraries,agencies, tripbooks, config

  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
